import { useMemo } from 'react';
import { getCurrencySymbol } from '@/lib/currency';

/** Minimal society shape needed to resolve a currency symbol. */
type CurrencySource = {
  currency?: string | null;
  country?: string | null;
};

/**
 * Memoised currency symbol for a society's `$`-format index values (e.g. `R`
 * for South Africa, `£` for the UK). Centralises the
 * `getCurrencySymbol(society.currency, society.country)` derivation shared by
 * the EBV tables, charts, sale catalogue, mating predictor and search filters.
 */
export function useCurrencySymbol(society: CurrencySource): string {
  return useMemo(
    () => getCurrencySymbol(society.currency, society.country),
    [society.currency, society.country],
  );
}
